import { render, staticRenderFns } from "./StartUp.vue?vue&type=template&id=07206a71&scoped=true&"
import script from "./StartUp.vue?vue&type=script&lang=js&"
export * from "./StartUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07206a71",
  null
  
)

export default component.exports